<template>
  <Modal
    v-model="visible"
    title="其他加扣款"
    width="800"
    class="my-modal top"
    :class="{ 'p-b': releaseStatus == '1' }"
    :mask-closable="false"
    :footer-hide="true"
  >
    <div class="tools-box add-btn">
      <Button type="primary" @click="addRow" v-if="releaseStatus == '0'">新增一行</Button>
    </div>

    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData" row-key="id">
        <template slot-scope="{ row, index }" slot="action">
          <span class="table-btn" @click="delRow(row, index)">删除</span>
        </template>
      </Table>
    </div>

    <div class="ivu-modal-footer" v-if="releaseStatus == '0'">
      <Button type="primary" @click="ok" :loading="loading">确定</Button>
      <Button @click="visible = false">取消</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ['reportId'],
  data() {
    return {
      visible: false,
      loading: false,
      columns: [],
      tableData: [],
      userId: null,
      releaseStatus: null
    };
  },
  methods: {
    async open(userId, releaseStatus) {
      this.releaseStatus = releaseStatus;
      this.userId = userId;
      if (releaseStatus == 0) {
        this.columns = [
          {
            title: '加扣款名称',
            align: 'center',
            key: 'deductionName',
            minWidth: 250,
            render: (h, params) => {
              return h('Form', [
                h('Input', {
                  props: {
                    type: 'text',
                    value: params.row['deductionName']
                  },
                  on: {
                    input: event => {
                      this.tableData[params.index]['deductionName'] = event;
                    }
                  }
                })
              ]);
            }
          },
          {
            title: '加扣款金额（税前）',
            align: 'center',
            key: 'deduction',
            minWidth: 250,
            render: (h, params) => {
              return h('Form', [
                h('Input', {
                  props: {
                    type: 'text',
                    value: params.row['deduction']
                  },
                  on: {
                    input: event => {
                      this.tableData[params.index]['deduction'] = event;
                    }
                  }
                })
              ]);
            }
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            width: 100,
            fixed: 'right'
          }
        ];
      } else {
        this.columns = [
          {
            title: '加扣款名称',
            align: 'center',
            key: 'deductionName',
            minWidth: 250
          },
          {
            title: '加扣款金额（税前）',
            align: 'center',
            key: 'deduction',
            minWidth: 250
          }
        ];
      }
      await this.getList();
      this.visible = true;
    },

    getList() {
      return this.$http({
        url: '/buz/userSalaryDeduction/queryList',
        type: 'POST',
        data: {
          reportId: this.reportId,
          userId: this.userId
        }
      }).then(res => {
        this.tableData = res.data;
      })
    },

    // 新增
    addRow() {
      this.tableData.push({
        deductionName: '',
        deduction: '',
        id: new Date().getTime()
      });
    },

    // 删除
    delRow(row, index) {
      this.tableData = this.tableData.filter((item, itemIndex) => index != itemIndex);
    },

    ok() {
      let flag = true;
      this.tableData.map(item => {
        if (!item.deductionName) {
          flag = false;
          this.$notice.msg('请填写加扣款名称');
          return;
        } else {
          flag = true;
        }
        if (!item.deduction) {
          flag = false;
          this.$notice.msg('请填写加扣款金额');
        } else {
          flag = true;
        }
      });

      if (flag) {
        let data = {
          userId: this.userId,
          reportId: this.reportId,
          userSalaryDeductionList: this.tableData.map(item => {
            return {
              deductionName: item.deductionName,
              deduction: item.deduction
            };
          })
        };
        this.$http({
          url: '/buz/userSalaryDeduction/saveDeduction',
          type: 'POST',
          data
        }).then(res => {
          this.visible = false;
          this.$notice.success('操作成功');
          this.$emit('success');
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-btn {
  margin: 10px 0 15px 0;
}
.table-box {
  margin-top: 10px;
}
</style>